/* eslint-disable require-jsdoc */
export class CuriosityCorruption {
    constructor() {
        this.uniqueSolutionAttempts = "";
        this.attemptResults = "";
        this.conspiracyStory = "";
        this.olderAttemptsBoolean = false;
        this.olderAttempts = "";
        this.olderAttemptResults = "";
        this.painPointBelief = "";
        this.outsideForcesBeliefBoolean = false;
        this.outsideForcesReason = "";
    }
}
